
'use client'

import { useState, useRef, useEffect } from 'react'
import {
  Catalog,
  CatalogItem
} from "@/components/Book";
import s from './KeyDom.module.css'

const Page = (props) => {
  const { cityData = [], isOnFocus, book} = props;
  const { selectedKey } = props;

  useEffect(()=>{
    if(cityData.length > 0){
      
    }
  }, [cityData])

  return (
    <Catalog className={s.citykeyclass} style={{ display: isOnFocus ? 'none' : '' }}>
      <div className={s.citykeyclass2} >
        <div className={s.citykeyclassgroup}>
          {cityData.map((item, idx) => {
             
            return (
              <CatalogItem
                className={`${s.citykeyclassitem}  ${book.active === `cg_${item?.groupName?.length > 1 ? '#' : item?.groupName}` ? s.keyitemselected01 : ''}`}
                id={`cg_${item?.groupName?.length > 1 ? '#' : item?.groupName}`}
                key={`cg_${idx}`}
              >{item?.groupName?.length > 1 ? '#' : item?.groupName}</CatalogItem>
            )
          })}
        </div>
      </div>
    </Catalog>
  );
};
export default Page;
